import { isString } from "../utils/schemaUtils";

export interface GitHubUser {
  id: string;
  login: string;
  url: string;
}

const isGitHubUser = (v: unknown): v is GitHubUser => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.login) && isString(r.url);
};

// Who can be assigned work in one repository, not who belongs to the
// organization: the App asks for no organization-level permission, so the
// member list is not readable.
export interface GitHubUsersPayload {
  type: "github_users";
  repo: string;
  users: GitHubUser[];
}

export const parseGitHubUsersPayload = (v: unknown): GitHubUsersPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_users") return null;
  if (!isString(r.repo)) return null;
  if (!Array.isArray(r.users) || !r.users.every(isGitHubUser)) return null;
  return {
    type: "github_users",
    repo: r.repo,
    users: r.users,
  };
};
